import { motion } from "framer-motion";
import MarketingLayout from "./MarketingLayout";
import { MarketingHero, fadeUp } from "./Blocks";

export default function LegalShell({ kicker, title, sub, updated, toc, sections, children, testId }) {
  return (
    <MarketingLayout>
      <div data-testid={testId}>
        <MarketingHero kicker={kicker} title={title} sub={sub} />
        <div className="bg-[#071B3A] py-14 sm:py-16">
          <div className="mx-auto max-w-7xl px-5">
            {updated && <p className="mono text-xs font-bold uppercase tracking-widest text-slate-500" data-testid={`${testId}-updated`}>Last Updated: {updated}</p>}
            {children}
            <div className="mt-10 grid gap-10 lg:grid-cols-[260px_minmax(0,1fr)]">
              <aside className="hidden lg:block">
                <div className="sticky top-24 rounded-2xl border border-white/10 bg-white/[0.04] p-5" data-testid={`${testId}-toc`}>
                  <p className="font-display text-xs font-bold uppercase tracking-widest text-slate-500">On This Page</p>
                  <nav className="mt-3 space-y-1">
                    {toc.map(([label, id]) => (
                      <a key={id} href={`#${id}`} data-testid={`${testId}-toc-${id}`}
                        className="block rounded-lg px-3 py-1.5 text-xs font-medium text-slate-400 transition-colors hover:bg-white/5 hover:text-shipany-cyan">{label}</a>
                    ))}
                  </nav>
                </div>
              </aside>
              <div className="space-y-5">
                {sections.map((s, i) => (
                  <motion.section key={s.id} id={s.id} {...fadeUp} data-testid={`${testId}-section-${s.id}`}
                    className="scroll-mt-24 rounded-2xl border border-slate-200 bg-white p-6 sm:p-8">
                    <h2 className="font-display text-lg font-bold text-shipany-navy sm:text-xl">{i + 1}. {s.h}</h2>
                    {(s.body || []).map((p, j) => (
                      <p key={j} className="mt-3 text-sm leading-relaxed text-slate-600 sm:text-[15px]">{p}</p>
                    ))}
                    {s.list && (
                      <ul className="mt-3 space-y-2">
                        {s.list.map((li) => (
                          <li key={li} className="flex items-start gap-2.5 text-sm text-slate-600 sm:text-[15px]">
                            <span className="mt-2 h-1.5 w-1.5 shrink-0 rounded-full bg-[#FF9933]" />{li}
                          </li>
                        ))}
                      </ul>
                    )}
                  </motion.section>
                ))}
              </div>
            </div>
          </div>
        </div>
      </div>
    </MarketingLayout>
  );
}
